import Chaplin from 'chaplin';

class EventManager {
  constructor(prefix) {
    if (typeof prefix !== 'string') {
      throw Error('EventManager: prefix must be a string');
    }
    this.prefix = `${prefix}:`;
    if (!Chaplin || !Chaplin.mediator) {
      throw Error('EventManager: Chaplin doesnt exists');
    }
    function checkParams(event, cb) {
      if (typeof cb !== 'function') {
        throw Error('EventManager: callback must be a function');
      }
      if (typeof event !== 'string') {
        throw Error('EventManager: event must be a string');
      }
    }
    this.on = (event, cb, ctx) => {
      checkParams(event, cb);
      return Chaplin.mediator.subscribe(`${this.prefix}${event}`, cb, ctx);
    };
    this.off = (event, cb, ctx) => {
      checkParams(event, cb);
      return Chaplin.mediator.unsubscribe(`${this.prefix}${event}`, cb, ctx);
    };
    this.trigger = (event, ...data) => {
      return Chaplin.mediator.publish(`${this.prefix}${event}`, ...data);
    };
  }
}

export default EventManager;
